import { AfterViewInit, Component, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from "@angular/forms";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { CompanyService } from 'src/app/services/company.service';
import { EventEmitter } from '@angular/core';
import Swal from 'sweetalert2';
import { AppCoreService } from 'src/app/services/app-core.service';
import { Utilities } from 'src/app/models/utilities';

@Component({
  selector: 'app-financial-year',
  templateUrl: './financial-year.component.html',
  styleUrls: ['./financial-year.component.scss']
})
export class FinancialYearComponent implements OnInit, AfterViewInit {
  @Input() financialYearList: any[];
  @Input() companyId: any;
  @Output() financialYearEmit = new EventEmitter<any>();

  financialYearForm: FormGroup;
  editMode = false;

  Id: number;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'autoHeight'
  }
  columnDefs = [
    { headerName: 'From Date', field: 'formatedFromDate', filter: true },
    { headerName: 'To Date', field: 'formatedToDate', filter: true },
    {
      headerName: 'Actions',
      field: 'id',
      // cellRendererParams: { context: this },
      cellRenderer: EditDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 150,
    },
  ];
  rowData: any[] = [];
  userData: any;
  useEnterKey: any;
  constructor(
    private fb: FormBuilder,
    private companyService: CompanyService,
    private toast: ToastrService,
    private appCoreService: AppCoreService,
    private utilities: Utilities,

  ) { this.context = { componentParent: this }; }

  ngOnInit(): void {
    this.financialYearForm = this.fb.group({
      ddlFromDate: [null],
      ddlToDate: [null],
    })
    this.userData = this.appCoreService.GetUserData();
    this.useEnterKey = !this.userData.metaInfo.tabbasedtemplate;
    this.onChangeDates();
    this.getFinancialYear();
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.financialYearForm) : null;
  }

  onChangeDates() {
    this.financialYearForm.get('ddlFromDate').valueChanges.subscribe((fromDate) => {
      // Calculate and set 'ddlToDate' based on 'ddlFromDate' (assuming one year financial period)
      if (fromDate) {
        const toDate = new Date(fromDate);
        toDate.setFullYear(toDate.getFullYear() + 1);
        this.financialYearForm.get('ddlToDate').setValue(toDate.toISOString().split('T')[0]);
      }
    });
  }

  //financial year
  async upsert() {
    try {

      const requestObj = {
        id: this.Id || null,
        companyid: this.companyId || null,
        fromdate: this.financialYearForm.get('ddlFromDate').value,
        todate: this.financialYearForm.get('ddlToDate').value,
      };
      if (requestObj.fromdate && requestObj.todate) {
        if (this.editMode) {
          this.update(requestObj);
          console.log('update requestObj', requestObj);

        } else {
          this.add(requestObj);
          // console.log('requestObj', requestObj);
          // this.rowData = [...this.rowData, requestObj];
          // this.financialYearList = this.rowData;
          this.financialYearEmit.emit(this.financialYearList);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  add(requestObj: any) {
    try {
      const res = this.companyService.AddFinancialYear(requestObj).subscribe((res) => {
        // console.log(res);
        if (res && res.success == false) {
          this.toast.error(res.message);
        }
        if (res && res.success) {
          this.getFinancialYear();
          this.toast.success('Record Added Successfully');
        }
      })
    } catch (error) {

    }
  }

  update(requestObj: any) {
    try {
      const res = this.companyService.UpdateFinancialYear(requestObj).subscribe((res) => {
        // console.log(res);
        if (!res?.success) {
          this.toast.error(res.message);
        }
        if (res && res.success) {
          this.getFinancialYear();
          this.toast.success('Record Updated Successfully');
        }
      })
    } catch (error) {

    }
  }
  async openErrorDialog(msg: any) {
    const result = await Swal.fire({
      title: 'Error',
      text: msg,
      icon: 'error',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  async editAction(cell: any) {
    try {
      if (cell && cell.id) {
        this.editMode = true;
        this.Id = cell.id;
        if (cell.fromdate && cell.todate) {
          this.financialYearForm.patchValue({
            ddlFromDate: cell.formatedFromDate,
            ddlToDate: cell.formatedToDate,
          })
        }
      }

    } catch (e) {
      console.error(e);
    }

  }
  async deleteAction(cell: any) {
    // console.log(cell);
    try {
      if (cell && cell.id) {
        this.openConfirmationDialog(cell.id);
      }

    } catch (e) {
      console.error(e);
    }

  }

  async openConfirmationDialog(id: number) {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      confirmButtonText: 'OK',
      showCancelButton: true,
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (result.isConfirmed) {
      this.deleteRecord(id);
    }
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.companyService.DeleteFinancialYearById(id).subscribe((res) => {
          if (res && res.success) {
            this.getFinancialYear();
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  getFinancialYear() {
    try {
      this.companyService.GetAllFinancialYearByCompanyId(this.companyId).subscribe((res) => {
        if (res && res.success) {
          for (const item of res.data) {
            item.formatedFromDate = this.formateDate(item.fromdate).dateString;
            item.formatedToDate = this.formateDate(item.todate).dateString;
          }
          this.rowData = res.data;
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  formateDate(date?: any) {
    const inputDate = date != null ? new Date(date) : new Date();
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
    const day = inputDate.getDate().toString().padStart(2, '0');
    const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
    const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
    const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
    const dateString = `${year}-${month}-${day}`;
    const newFinancialYrDate = new Date(inputDate);
    newFinancialYrDate.setFullYear(newFinancialYrDate.getFullYear() + 1);
    const financialYr = newFinancialYrDate.toISOString().split('T')[0];

    return { dateString, dateTimeString, financialYr };
  }
}
